<template>
  <v-container fluid>
    <v-form v-model="valid">
      <v-card>
        <v-card-title>
          <span class="headline mb-0">権限詳細</span>
        </v-card-title>
        <v-card-actions>
          <v-btn
            :disabled="!valid"
            @click="save"
            v-permit.SHARP_AUTHORITY_NEW
            >{{ $t("app.buttons.save") }}</v-btn
          >
          <v-btn @click="$router.go(-1)">{{ $t("app.buttons.back") }}</v-btn>
        </v-card-actions>
        <v-container fluid>
          <v-layout>
            <v-flex md3 sm6 xs12>
              <v-text-field
                :rules="codeRules"
                clearable
                label="権限グループCD"
                required
                v-model.trim="form.roleCode"
              />
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex md3 sm6 xs12>
              <v-text-field
                :rules="nameRules"
                clearable
                label="権限グループ名"
                required
                v-model.trim="form.roleName"
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-form>
  </v-container>
</template>
<script>
/* eslint-disable no-console */
export default {
  data() {
    return {
      valid: true,
      form: {},
      codeRules: [(v) => !!v || "権限グループCD is required"],
      nameRules: [(v) => !!v || "権限グループ名 is required"],
    };
  },
  methods: {
    save() {
      this.$http
        .post(
          `/auth-service/auth/create-role?roleCode=${this.form.roleCode}&roleName=${this.form.roleName}`
        )
        .then((res) => {
          if (res.data.success) {
            this.$message(
              this.$t("app.messages.success.title"),
              this.$t("app.messages.saveSuccess")
            );
            this.$router.go(-1);
          } else {
            this.$message(this.$t("app.messages.errors.title"), "FAILED");
          }
        })
        .catch(() => {
          this.$message(this.$t("app.messages.errors.title"), "FAILED");
        });
    },
  },
};
</script>
